export const hasWordIntegration = (government) => {
    return government.hasWordIntegration === true;
};
